import React, { useEffect, useContext, useState } from "react"
import { SectionContext } from "../context/sectionContext"
import { ErrorContext } from "../context/errorContext"
import { ConditionContext } from "../context/conditionContext"
import {JourneyContext} from "../context/journeyContext"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/swiper.min.css"
import "swiper/components/navigation/navigation.min.css"
import SwiperCore, { Navigation } from "swiper/core"
import { getAge, getValueFromJourney,getValueFromLookup } from "../services/helperFunctions"
import { lineCapital } from "../../shared/functions"
import { fetchAllJourneyData } from "../../services/apiservice"
SwiperCore.use([Navigation])

const radioCardFormControlKey = [
  "CPCustomizePlanQuestionOne",
  "iSelect360CPCustomizePlanQuestionOne",
  "CPChooseYourPlan",
  "CPOptionInBuilt",
  'CPSpouseOptionBuilt'
]

const tabFormControlKey = ["CPChooseYourPlan"]
const carouselFormControlKey = ["CPCustomizePlanQuestionOne", "iSelect360CPCustomizePlanQuestionOne"]

const breakpoints = length => ({
  // when window width is <= 1023px
  1023: {
    slidesPerView: length,
    allowSlideNext: false,
    allowSlidePrev: false,
  },
  // when window width is <= 767px
  767: {
    slidesPerView: 1,
    allowSlideNext: true,
    allowSlidePrev: true,
  },
})

export default function ComponentTextSimpleRadioGroup(props) {
  console.log(props.data, "props.data")
  const [activeTab, setActiveTab] = useState(props.data.radioComponent[0].name)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)

  const validate = (target) => {
    if (props.data.required) {
      const value = target?.value ?? sectionState.sectionData?.[props.data.formControlKey]
      if (!value) {
        setErrorState(prev => ({
          ...prev,
          [props.data.formControlKey]: props.data.requiredError
            ? lineCapital(getValueFromLookup(
              "required_error",
              props.data.requiredError
            ))
            : "Error Code Not Found in Strapi",
        }))
      } else {
        setErrorState(prev => ({
          ...prev,
          [props.data.formControlKey]: "",
        }))
      }
    }
  }

  useEffect(() => {
    validate({ value: sectionState.sectionData?.[props.data.formControlKey] ?? "" })
  }, [sectionState.sectionData?.[props.data.formControlKey]])

  let arr = {}

  useEffect(() => {
    if (!sectionState.sectionData?.[props.data.formControlKey]) {
      props.data.radioComponent.map(element => {
        if (element.checked) {
          if (sectionState.sectionId === props.sectionId) {
            setSectionState(prev => {
              return {
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: element.value,
                },
              }
            })
          } else {
            setSectionState(prev => {
              return {
                ...prev,
                sectionId: props.sectionId,
                sectionData: {
                  ...prev.sectionData,
                  [props.data.formControlKey]: element.value,
                },
              }
            })
          }
          setConditionState(prev => {
            return {
              ...prev,
              [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: element.value,
            }
          })
        }
      })
    }else{
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: sectionState.sectionData[props.data.formControlKey],
        }
      })
    }
    if (props.pageId === "pageISelect360FillProposalForm" && props.sectionId === "AppointeeDetailSection" && props.data.formControlKey
    === "appointeeAddressSameAsLaOthers"){
      let payload = {
        journeyId: journeyState.journeyId,
      }
      if (sectionState.sectionData.appointeeAddressSameAsLaOthers === undefined || sectionState.sectionData.appointeeAddressSameAsLaOthers === ""){
        setTimeout(() => {
          fetchAllJourneyData(payload).then(data => {
            let city = ''
            let pincode = ''
            let state = ''
            let address1 = ''
            let address2 = ''
            let address3 = ''
            let country = ''
            let dontFreezeCountry = false;
            const nominees = data.nominees;
            if (nominees){
              const firstMinorNominee = nominees.find(nominee => {
                if (getAge(nominee.dob) < 18){
                  return true;
                }else{
                  return false;
                }
              })
              pincode = firstMinorNominee.communicationDetails.pinCode
              city = firstMinorNominee.communicationDetails.cityMap
              state = firstMinorNominee.communicationDetails.state
              address1 = firstMinorNominee.communicationDetails.address1
              address2 = firstMinorNominee.communicationDetails.address2
              address3 = firstMinorNominee.communicationDetails.areaTalukaTehsil ? firstMinorNominee.communicationDetails.areaTalukaTehsil : firstMinorNominee.communicationDetails.address3
              country = firstMinorNominee.communicationDetails.country
            }
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["appointeePincode"]: pincode,
                  ["appointeeState"] : state,
                  ["cityAppointee"] : city,
                  ["address1appointee"] : address1,
                  ["address2appointee"] : address2,
                  ["address3appointee"] : address3,
                  ["appointeeCountry"] : country
                }
              })
            })
            freezeAndUnfreezeAppointeeAddressFields(pincode,state,city,address1,address2,address3,country,dontFreezeCountry);
          })
        },2000)
      }else{
        let payload = {
          journeyId: journeyState.journeyId,
        }
        setTimeout(() => {
          fetchAllJourneyData(payload).then(data => {
            let cityAppointee = ''
            let appointeePincode = ''
            let appointeeState = ''
            let address1appointee = ''
            let address2appointee = ''
            let address3appointee = ''
            let country = ''
            let dontFreezeCountry = false;
            let addressSameAs = data.nominees[0].appointee.addressSameAs;
            if (addressSameAs === "Life Assured"){
              appointeePincode = data.lifeAssuredDetails.communicationDetails.currentAddress.pinCode
              appointeeState = data.lifeAssuredDetails.communicationDetails.currentAddress.state
              cityAppointee = data.lifeAssuredDetails.communicationDetails.currentAddress.cityMap
              address1appointee = data.lifeAssuredDetails.communicationDetails.currentAddress.address1
              address2appointee = data.lifeAssuredDetails.communicationDetails.currentAddress.address2
              address3appointee = data.lifeAssuredDetails.communicationDetails.currentAddress.address3
              country = data.lifeAssuredDetails.communicationDetails.currentAddress.country
            }else if (addressSameAs === "Nominee"){
              const nominees = data.nominees;
              const firstMinorNominee = nominees.find(nominee => {
                if (getAge(nominee.dob) < 18){
                  return true;
                }else{
                  return false;
                }
              })
              appointeePincode = firstMinorNominee.communicationDetails.pinCode
              cityAppointee = firstMinorNominee.communicationDetails.cityMap
              appointeeState = firstMinorNominee.communicationDetails.state
              address1appointee = firstMinorNominee.communicationDetails.address1
              address2appointee = firstMinorNominee.communicationDetails.address2
              address3appointee = firstMinorNominee.communicationDetails.areaTalukaTehsil ? firstMinorNominee.communicationDetails.areaTalukaTehsil : firstMinorNominee.communicationDetails.address3
              country = firstMinorNominee.communicationDetails.country
            }else if (addressSameAs === "Others"){
              appointeePincode = ''
              appointeeState = ''
              cityAppointee = ''
              address1appointee = ''
              address3appointee = ''
              address3appointee = ''
              let tempPageIndexToChange ;
              let tempSectionIndexToChange;
              let tempComponentGroupIndextoChange;
              let temp = journeyState.journeySteps
              tempPageIndexToChange = temp.pages.findIndex(page => page.pageId === "pageISelect360FillProposalForm")
              tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(section => section.sectionId  === "AppointeeDetailSection")
              tempComponentGroupIndextoChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(components => components.componentId === "AppointeeCommuncationDetailsTermPlan");
              let defaultValue = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChange].components[7].defaultValue
              country = defaultValue ? defaultValue : 'IN';
              dontFreezeCountry = true
            }
            setSectionState(prev => {
              return ({
                ...prev,
                sectionData: {
                  ...prev.sectionData,
                  ["appointeePincode"]:appointeePincode,
                  ["appointeeState"] : appointeeState,
                  ["cityAppointee"] : cityAppointee,
                  ["address1appointee"] : address1appointee,
                  ["address2appointee"] : address2appointee,
                  ["address3appointee"] : address3appointee,
                  ["appointeeCountry"] : country
                }
              })
            })
            freezeAndUnfreezeAppointeeAddressFields(appointeePincode,appointeeState,cityAppointee,address1appointee,address2appointee,address3appointee,country,dontFreezeCountry);
          })
        },2000)
      }
}
  }, [])

  const createCardSet = () => {
    let cardContainers = document.querySelectorAll(".radio-card-container")

    cardContainers.forEach(cardContainer => {
      cardContainer.querySelectorAll("[data-active-class]").forEach(el => {
        let dataActiveClass = el.getAttribute("data-active-class")
        if (arr[dataActiveClass]) {
          arr[dataActiveClass] = [...arr[dataActiveClass], el]
        } else {
          arr[dataActiveClass] = [el]
        }
      })
    })
  }
  createCardSet()

  const handleActiveTab = ({ target }, value) => {
    if (target.getAttribute("data-active-tab")) {
      Array.from(target.parentElement.parentElement.children).forEach(el => {
        el.classList.remove("active-tab")
      })
      target.parentElement.classList.add("active-tab")
      setActiveTab(value)
    }
  }

  const handleEnter = (event1,event2,isCard) =>{
    if(event1.key == 'Enter'){
      handleChange(event2,isCard)
    }
  }
  const handleChange = ({ target }, isCard) => {
    console.log(target.value);
    if(!props.data.disabled){
      if (sectionState.sectionId === props.sectionId) {
        setSectionState(prev => {
          return {
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: target.value,
            },
          }
        })
      } else {
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: props.sectionId,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: target.value,
            },
          }
        })
      }
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: target.value,
        }
      })

      if (target.value && isCard) {
        console.log(target.value)
        // console.log(target.value);
        // smoke-white-clr
        // console.log(target.parentElement.parentElement.parentElement)

        // radio-cards by Id
        let currentRadio = document
          .getElementById(target.value)
          .querySelector("[data-active-class]")
        console.log(currentRadio)
        // let parent = currentRadio.parentElement.querySelectorAll(".radio-card")

        // removing other active class
        let radios = arr[currentRadio.getAttribute("data-active-class")]
        radios?.forEach(radio => {
          radio.classList.remove("active")
        })

        // activate radio Radio
        currentRadio.classList.add("active")
      }

      if(!isCard && props.saveApplicationAndCallBi){
        props.saveApplicationAndCallBi(props.data.formControlKey, target.value)
      }
      validate({ value: target.value })
      console.log(sectionState, "section state")
      // console.log(conditionState, "condition state")
      if (props.pageId === "pageISelect360FillProposalForm" && props.sectionId === "AppointeeDetailSection" && props.data.formControlKey
      === "appointeeAddressSameAsLaOthers" ){
     
       let payload = {
         journeyId: journeyState.journeyId,
       }
       fetchAllJourneyData(payload).then(data => {
         let cityAppointee = ''
         let appointeePincode = ''
         let appointeeState = ''
         let address1appointee = ''
         let address2appointee = ''
         let address3appointee = ''
         let country = ''
         let dontFreezeCountry = false;
         if (target.value === "Life Assured"){
           appointeePincode = data.lifeAssuredDetails.communicationDetails.currentAddress.pinCode
           appointeeState = data.lifeAssuredDetails.communicationDetails.currentAddress.state
           cityAppointee = data.lifeAssuredDetails.communicationDetails.currentAddress.cityMap
           address1appointee = data.lifeAssuredDetails.communicationDetails.currentAddress.address1
           address2appointee = data.lifeAssuredDetails.communicationDetails.currentAddress.address2
           address3appointee = data.lifeAssuredDetails.communicationDetails.currentAddress.address3
           country = data.lifeAssuredDetails.communicationDetails.currentAddress.country
         }else if (target.value === "Nominee"){
           const nominees = data.nominees;
           const firstMinorNominee = nominees.find(nominee => {
             if (getAge(nominee.dob) < 18){
               return true;
             }else{
               return false;
             }
           })
           appointeePincode = firstMinorNominee.communicationDetails.pinCode
           cityAppointee = firstMinorNominee.communicationDetails.cityMap
           appointeeState = firstMinorNominee.communicationDetails.state
           address1appointee = firstMinorNominee.communicationDetails.address1
           address2appointee = firstMinorNominee.communicationDetails.address2
           address3appointee = firstMinorNominee.communicationDetails.areaTalukaTehsil ? firstMinorNominee.communicationDetails.areaTalukaTehsil : firstMinorNominee.communicationDetails.address3
           country = firstMinorNominee.communicationDetails.country
          }else if (target.value === "Others"){
           appointeePincode = ''
           appointeeState = ''
           cityAppointee = ''
           address1appointee = ''
           address3appointee = ''
           address3appointee = ''
           let tempPageIndexToChange ;
           let tempSectionIndexToChange;
           let tempComponentGroupIndextoChange;
           let temp = journeyState.journeySteps
           tempPageIndexToChange = temp.pages.findIndex(page => page.pageId === "pageISelect360FillProposalForm")
           tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(section => section.sectionId  === "AppointeeDetailSection")
           tempComponentGroupIndextoChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(components => components.componentId === "AppointeeCommuncationDetailsTermPlan");
           let defaultValue = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChange].components[7].defaultValue
           country = defaultValue ? defaultValue : 'IN';
           dontFreezeCountry = true;
          }
         setSectionState(prev => {
           return ({
             ...prev,
             sectionData: {
               ...prev.sectionData,
               ["appointeePincode"]:appointeePincode,
               ["appointeeState"] : appointeeState,
               ["cityAppointee"] : cityAppointee,
               ["address1appointee"] : address1appointee,
               ["address2appointee"] : address2appointee,
               ["address3appointee"] : address3appointee,
               ["appointeeCountry"] : country
             }
           })
         })
         freezeAndUnfreezeAppointeeAddressFields(appointeePincode,appointeeState,cityAppointee,address1appointee,address2appointee,address3appointee,country,dontFreezeCountry);
       })
     }
    }
  }
  const freezeAndUnfreezeAppointeeAddressFields = (appointeePincode,appointeeState,cityAppointee,address1appointee,address2appointee,address3appointee,country,dontFreezeCountry = false) => {
    let tempPageIndexToChange ;
    let tempSectionIndexToChange;
    let tempComponentGroupIndextoChange;
    let temp = journeyState.journeySteps
    tempPageIndexToChange = temp.pages.findIndex(page => page.pageId === "pageISelect360FillProposalForm")
    tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(section => section.sectionId  === "AppointeeDetailSection")
    tempComponentGroupIndextoChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(components => components.componentId === "AppointeeCommuncationDetailsTermPlan");
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChange].components[1].disabled = address1appointee ? true : false
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChange].components[2].disabled = address2appointee ? true : false
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChange].components[3].disabled = address3appointee ? true : false
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChange].components[4].disabled = appointeePincode ? true : false
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChange].components[5].disabled = appointeeState ? true : false
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChange].components[6].disabled = cityAppointee ? true : false
    temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndextoChange].components[7].disabled = country ? (dontFreezeCountry ? false : true) : false
    setJourneyState(prev => {
      return ({
        ...prev,
        journeySteps: temp
      })
    })
  }
  return (
    <>
      <style>
        {`
        .radio-tab {
          display: flex;
          justify-content:space-evenly;
          margin-bottom:2rem;
          border:1px solid black;
        }
        .radio-tab > *{
          color:black;
          background:transparent;
          padding:0;
          flex:1;
          padding: 4px 0;

        }

        .radio-tab p{
          margin:0;
          
        }

        .active-tab{
          background-color: ${props.channel === "A" ? "#000000" : props.channel === "B" ? "#a20a3a" : props.channel === "C" ? "#0ab0ef" : "#eb7f25"};
          background-color: var(--lumiq-secondary);
          color:white
        }
        .card-label {
          height:3rem;
          text-align:center;
          font-weight:bold;
        }
        
        `}
      </style>
      {radioCardFormControlKey.includes(props.data.formControlKey) ? (
        <>
          <p className="text-left plan-heading new-heading-font">
            {/* {props.data.label} */}
            {(getValueFromLookup(
            "label",
            props.data.label
          )) || props.data.label}
           
          </p>

          {carouselFormControlKey.includes(props.data.formControlKey) ? (
            <div className="row radio-card-container">
              <Swiper
                navigation={true}
                autoplay={true}
                breakpoints={breakpoints(props.data.radioComponent.length)}
              >
                {props.data.radioComponent.map((element, i) => {
                  return (
                    <SwiperSlide>
                      <div
                        className={`radio-card ${element.class}`}
                        style={{
                          width:"100%"
                        }}
                        key={i}
                        name={element.name}
                        id={element.value}
                        checked={
                          sectionState.sectionData[props.data.formControlKey]
                          ? sectionState.sectionData[
                            props.data.formControlKey
                          ] === element.value
                          : element.checked
                        }
                        
                        onKeyPress= {(e)=>handleEnter(e,
                          { target: { value: element.value } },
                          true
                        )}
                        onClick={e =>
                          handleChange(
                            { target: { value: element.value } },
                            true
                          )
                        }
                      >
                        <div
                          dangerouslySetInnerHTML={{ __html: element.html }}
                        />
                      </div>
                    </SwiperSlide>
                  )
                })}
              </Swiper>
            </div>
          ) : (
            <div className="row radio-card-container ">
              {tabFormControlKey.includes(props.data.formControlKey) ? (
                <div className="radio-tab hidden-lg hidden-md hidden-sm ">
                  {props.data.radioComponent.map((el, i) => {
                    if (el.label) {
                      return (
                        <div
                          className={`${
                            props.data.radioComponent[0].name == el.name
                              ? "active-tab"
                              : ""
                          }`}
                        >
                          <p
                            data-active-tab={el.value}
                            aria-hidden="true"
                            onClick={e => handleActiveTab(e, el.name)}
                            className="text-center"
                            style={{ fontSize: "1.5rem" }}
                          >
                            {el.label}
                          </p>
                        </div>
                      )
                    }
                  })}
                </div>
              ) : null}
              {props.data.radioComponent.map((element, i) => {
                return (
                  <div
                    className={`radio-card ${element.class}`}
                    key={i}
                    name={element.name}
                    id={element.value}
                    checked={
                      sectionState.sectionData[props.data.formControlKey]
                        ? sectionState.sectionData[
                            props.data.formControlKey
                          ] === element.value
                        : element.checked
                    }
                    onKeyPress= {(e)=>handleEnter(e,
                      { target: { value: element.value } },
                      true
                    )}
                    onClick={e =>
                      handleChange({ target: { value: element.value } }, true)
                    }
                  >
                    {tabFormControlKey.includes(props.data.formControlKey) ? (
                      <p className="card-label text-left plan-heading new-heading-font hidden-xs">
                        {element.label}
                      </p>
                    ) : null}
                    {tabFormControlKey.includes(props.data.formControlKey) ? (
                      <div
                        dangerouslySetInnerHTML={{ __html: element.html }}
                        className={activeTab == element.name ? "" : "hidden-xs"}
                      />
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: element.html }} />
                    )}
                  </div>
                )
              })}
            </div>
          )}
        </>
      ) : (
        <>
          <div className="form-group">
            <div className="radio-section-design">
           {/* <p>{props.data.label}</p> */}
           <p>{(getValueFromLookup(
                "label",
                props.data.label
              )) || props.data.label}</p>
            </div>
            <div style={{ overflow: "hidden", width: "100%", paddingBottom: "3px" }}>
            {props.data.radioComponent.map((element, i) => {
              return (
                <div className="radio-line radio-design" key={i}>
                  <label className="customradio">
                    <span className="radiotextsty inp-label">
                    {(getValueFromLookup(
                    "label",
                    element.label
                  )) || element.label}
                    </span>
                    <input
                      type={element.type}
                      name={element.name}
                      id={element.value}
                      value={element.value}
                      checked={ sectionState.sectionData &&
                        sectionState.sectionData[props.data.formControlKey]
                          ? sectionState.sectionData[
                              props.data.formControlKey
                            ] === element.value
                          : element.checked
                      }
                      onChange={handleChange}
                    />
                    <span tabIndex="0" className="provider checkmark" onKeyPress={(e)=>handleEnter(e,{target:{value:element.value}},false)}  ></span>
                  </label>
                </div>
              )
            })}
            </div>
            {props.data.required && (
              <span className="input-error" style={{ clear: "both", width: "100%" }}>
                {props.showError && errorState[props.data.formControlKey]}
              </span>
            )}
          </div>
        </>
      )}
    </>
  )
}
